var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-exprie"},[_c('img',{attrs:{"src":_vm.theme === 'union' ? _vm.unionImg : _vm.linkImg}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.expire?.message)),(_vm.expire?.type === 'date')?_c('span',[_vm._v("联系电话：18180479171")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }